export default __webpack_public_path__ + "static/media/boat-bottom.a1219f85.svg";